// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1736":"a216976b","6532":"3612fc62"}[chunkId] + ".chunk.css";
};